import { Routes } from "@angular/router";

export const LAYOUT_ROUTES: Routes = [
    {
        path: "",
        loadChildren: "./fintech/fintech.module#FintechModule"
    }
];
